import React, {useEffect, useState} from 'react';
import cn from 'classnames';
import { IBaseElementProps } from '../BasicElement';
import { ILink } from '../Button';
import Image, { IImage } from '../Image';

export interface IVHSLogoBarItems {
	/**
	 * Item Link
	 */
	link?: ILink;
	/**
	 * Item Image
	 */
	image?: IImage;
}
export interface IVHSLogoBarProps extends IBaseElementProps {
	/**
	 * Heading
	 */
	heading?: string;
	/**
	 * Items
	 */
	items?: IVHSLogoBarItems[];
	/**
	 * Greyscale
	 */
	greyscale?: boolean;
}

/**
 * Logo Bar
 * @block
 * @icon images-alt
 */
const VHSLogoBar: React.FC<IVHSLogoBarProps> = ({
	heading,
	items = [],
	greyscale = false,
	className,
	classNames = [],
}) => {
	const [displayItems, setDisplayItems] = useState<IVHSLogoBarItems[]>([]);

	useEffect( () => {
		if ( items.length > 0 ) {
			// randomize the order of the items
			items.sort( () => Math.random() - 0.5 );
			setDisplayItems(items)
		}
	}, items );

	return (
		<div className={className || cn('vhs-logo-bar', ...classNames)}>
			<div className="vhs-logo-bar__container">
				{heading && (
					<h2 className="vhs-logo-bar__heading">{heading}</h2>
				)}
				{displayItems.length > 0 && (
					<div className="vhs-logo-bar__wrapper">
						{displayItems.map(({ link, image }, index) => {
							return (
								<div
									key={index}
									className="vhs-logo-bar__image-wrapper"
								>
									{link?.href && link.href !== '#' ? (
										<a
											href={link.href}
											target={link.target || '_self'}
										>
											<Image
												{...image}
												className={cn(
													'vhs-logo-bar__image',
													greyscale === true &&
														'vhs-logo-bar__image--greyscale',
												)}
											/>
										</a>
									) : (
										<Image
											{...image}
											className={cn(
												'vhs-logo-bar__image',
												greyscale === true &&
													'vhs-logo-bar__image--greyscale',
											)}
										/>
									)}
								</div>
							);
						})}
					</div>
				)}
			</div>
		</div>
	);
};

export default VHSLogoBar;

